import React from 'react';
import { useRouter } from 'next/navigation';
import { useSelector } from 'react-redux';

const imgComponent1 = "/images/assets/9b233eb3f3d133c8c9ca388526cfa8718ad4e843.png";

function Frame58() {
  return (
    <div className="content-stretch flex flex-col items-start relative shrink-0 w-full max-w-[1034px]">
      <p className="font-['Roboto:Medium',sans-serif] font-medium leading-tight text-3xl sm:text-4xl md:text-[40px] lg:text-[48px] relative shrink-0 text-center text-white w-full" style={{ fontVariationSettings: "'wdth' 100" }}>
        Get Started Today
      </p>
    </div>
  );
}

function Frame99() {
  return (
    <div className="content-stretch flex flex-col gap-6 md:gap-8 items-center relative shrink-0 w-full px-4">
      <Frame58 />
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-6 md:leading-7 relative shrink-0 text-sm sm:text-base text-center text-white w-full max-w-[850px]" style={{ fontVariationSettings: "'wdth' 100" }}>
        Whether it's a personal need or a business project, hiring skilled professionals has never been this easy.
        <br aria-hidden="true" className="hidden sm:block" />
        {` Join hundreds of clients who trust HyreLancer to connect them with the best freelancers.`}
      </p>
    </div>
  );
}

function Frame89({ onPostRequirement, onFindFreelancer }) {
  return (
    <div className="content-stretch flex flex-col sm:flex-row gap-3 sm:gap-4 items-stretch sm:items-start relative shrink-0 w-full sm:w-auto px-4 sm:px-0">
      <button 
        onClick={onPostRequirement}
        className="box-border content-stretch flex gap-[10px] h-[44px] sm:h-[48px] items-center justify-center px-6 sm:px-8 py-3 sm:py-4 relative rounded-[24px] shrink-0 hover:bg-white/10 transition-all w-full sm:w-auto"
      >
        <div aria-hidden="true" className="absolute border border-solid border-white inset-[-0.5px] pointer-events-none rounded-[24.5px]" />
        <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-6 relative shrink-0 text-sm sm:text-base text-nowrap text-white whitespace-pre" style={{ fontVariationSettings: "'wdth' 100" }}>
          Post Your Requirement Now
        </p>
      </button>
      <button 
        onClick={onFindFreelancer}
        className="bg-white box-border content-stretch flex gap-[10px] h-[44px] sm:h-[48px] items-center justify-center px-6 sm:px-8 py-3 sm:py-4 relative rounded-[24px] shrink-0 hover:bg-opacity-90 transition-all w-full sm:w-auto"
      >
        <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-6 relative shrink-0 text-[#3a599c] text-sm sm:text-base text-nowrap whitespace-pre" style={{ fontVariationSettings: "'wdth' 100" }}>
          Find a Freelancer
        </p>
      </button>
    </div>
  );
}

function Frame64({ onPostRequirement, onFindFreelancer }) {
  return (
    <div className="content-stretch flex flex-col gap-8 md:gap-10 lg:gap-12 items-center justify-center relative shrink-0 w-full">
      <Frame99 />
      <Frame89 onPostRequirement={onPostRequirement} onFindFreelancer={onFindFreelancer} />
    </div>
  );
}

function Frame54({ onPostRequirement, onFindFreelancer }) {
  return (
    <div className="box-border content-stretch flex flex-col items-center justify-center overflow-clip px-4 sm:px-8 md:px-12 lg:px-16 py-12 sm:py-14 md:py-16 lg:py-20 relative rounded-2xl md:rounded-3xl lg:rounded-[24px] shrink-0 w-full max-w-[1633px]">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none rounded-2xl md:rounded-3xl lg:rounded-[24px]">
        <div className="absolute bg-[#3a599c] inset-0 rounded-2xl md:rounded-3xl lg:rounded-[24px]" />
        <img alt="" className="absolute max-w-none object-center object-cover opacity-[0.08] rounded-2xl md:rounded-3xl lg:rounded-[24px] size-full" src={imgComponent1} />
      </div>
      <div className="relative z-10 w-full">
        <Frame64 onPostRequirement={onPostRequirement} onFindFreelancer={onFindFreelancer} />
      </div>
    </div>
  );
}

export default function CTASection() {
  const router = useRouter();
  const { user, token, isAuthenticated } = useSelector(state => state.auth);

  const handlePostRequirement = () => {
    if (!isAuthenticated && !token && !user) {
      router.push('/login');
      return;
    }

    const userType = user?.user_type;
    if (userType === "Customer" || userType === "customer") {
      router.push('/customer-dashboard/job-post');
    } else if (userType === "Freelancer" || userType === "freelancer") {
      router.push('/freelancer-dashboard/jobs');
    } else {
      router.push('/login');
    }
  };

  const handleFindFreelancer = () => {
    router.push('/dummy-freelancers');
  };

  return (
    <div className="content-stretch flex flex-col items-center relative shrink-0 w-full py-8 md:py-12 lg:py-16 px-4 md:px-8 lg:px-16">
      <Frame54 onPostRequirement={handlePostRequirement} onFindFreelancer={handleFindFreelancer} />
    </div>
  );
}

